// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconBook = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M30 18.6329L30.1222 51.6418C30.1221 52.8741 29.3809 54 28.1366 54C25.1363 54 22.3144 50 7.9856 50C6.74146 50 6.00006 49.5941 6 48.3582V12.3582C6.00006 11.1259 6.74127 10 7.9856 10C21.3767 10 30 14.4026 30 18.6329ZM56.0144 10C42.6233 10 34 14.4026 34 18.6329L33.8778 51.6418C33.8779 52.8741 34.6191 54 35.8634 54C38.8637 54 41.6856 50 56.0144 50C57.2585 50 57.9999 49.5941 58 48.3582V12.3582C57.9999 11.1259 57.2587 10 56.0144 10Z" />
    </svg>
  );
};
